import React, { Component } from "react";
import { IntroPage } from "app/components/IntroPage";


import './QuotaHomeComponent.scss';

class QuotaHome extends Component{
    render() {		
        return (
            <IntroPage headerText="Quota Definitions">                
                <b>Here you can</b>
                <ul className="introHomeItems">
					<li>Create new Quota Definitions</li>
					<li>Search for existing Quota Definitions</li>
					<li>Review and manage existing Quota Definitions</li>
                </ul>
            </IntroPage>
        )
    }
}

export default QuotaHome;